var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "main",
    { staticClass: "i-main", attrs: { role: "main" } },
    [
      _c(
        "section",
        { staticClass: "main-krpano-wrapper" },
        [
          _vm.isNoPanoramasFound
            ? _c("div", { staticClass: "full-center error-wrapper" }, [
                _c("figure", { staticClass: "error-wrapper-container" }, [
                  _c("img", {
                    attrs: { src: _vm.noPanoramasImage, alt: "no panoramas" },
                  }),
                  _vm._v(" "),
                  _c("h3", [_vm._v(_vm._s(_vm.$t("noPanoramas")))]),
                ]),
              ])
            : [
                _vm.currentPanorama.videoAttribute
                  ? _c("video-panorama", {
                      key: _vm.currentPanorama.index,
                      attrs: { video: _vm.currentPanorama.videoAttribute },
                      on: { end: _vm.redirectToNextPanorama },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("krpano", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.currentPanorama.videoAttribute,
                      expression: "!currentPanorama.videoAttribute",
                    },
                  ],
                  attrs: {
                    "is-mouse-on-marker-info": _vm.isMouseOnMarkerInfo,
                    "is-mouse-on-krpano-marker": _vm.isMouseOnKrpanoMarker,
                    "mouseenter-marker": _vm.mouseenterMarker,
                    "mouseleave-marker": _vm.mouseleaveMarker,
                  },
                  on: {
                    setMarkerPositionX: function ($event) {
                      _vm.markerPositionX = $event
                    },
                    setMarkerPositionY: function ($event) {
                      _vm.markerPositionY = $event
                    },
                    setIsMouseOnKrpanoMarker: function ($event) {
                      _vm.isMouseOnKrpanoMarker = $event
                    },
                    "hook:narration": _vm.onNarrationSelected,
                    "launch-videoplay-fullscreen": function ($event) {
                      _vm.isVideoplayFullscreen = true
                    },
                    startup: function ($event) {
                      _vm.isHaveStartUp = true
                    },
                  },
                }),
              ],
        ],
        2
      ),
      _vm._v(" "),
      _c("viewer-markers-hover", {
        attrs: {
          "marker-position-x": _vm.markerPositionX,
          "marker-position-y": _vm.markerPositionY,
          "is-mouse-on-marker-info": _vm.isMouseOnMarkerInfo,
          "is-mouse-on-krpano-marker": _vm.isMouseOnKrpanoMarker,
          "mouseenter-marker": _vm.mouseenterMarker,
          "mouseleave-marker": _vm.mouseleaveMarker,
        },
        on: {
          setMouseOnMarkerInfo: function ($event) {
            _vm.isMouseOnMarkerInfo = $event
          },
        },
      }),
      _vm._v(" "),
      _c(
        "viewer-layer",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.isVrMode && _vm.markerInfoData.type !== "gallery",
              expression: "!isVrMode && markerInfoData.type !== 'gallery'",
            },
          ],
          staticClass: "bounce-in",
          class: {
            "bounce-in-active":
              _vm.isMarkerInfoActive && !_vm.isArViewPopupActive,
          },
          attrs: {
            "inner-class-name":
              _vm.markerInfoData.type === "multitag"
                ? "viewer-layer-enlarge no-close-btn"
                : "",
            "close-event": _vm.closeMarkerInfo,
          },
          scopedSlots: _vm._u([
            {
              key: "inner-extra",
              fn: function () {
                return [
                  _vm.favoritesMarkerTypes.includes(_vm.markerInfoData.type)
                    ? _c("i-favorite", {
                        attrs: { category: "marker", item: _vm.markerInfoData },
                      })
                    : _vm._e(),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm._v(" "),
          _c(
            "ul",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.markerInfoData.type === "memo",
                  expression: "markerInfoData.type === 'memo'",
                },
              ],
              staticClass: "viewer-layer-tabs",
            },
            [
              _c("li", { staticClass: "viewer-layer-li full-width" }, [
                _vm.markerInfoData.nameMulti
                  ? _c("span", { staticClass: "viewer-layer-text" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.markerInfoData.nameMulti[_vm.$i18n.locale] ||
                              _vm.markerInfoData.name
                          ) +
                          "\n        "
                      ),
                    ])
                  : _c("span", { staticClass: "viewer-layer-text" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.markerInfoData.name) +
                          "\n        "
                      ),
                    ]),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "viewer-layer-container" },
            [_c("marker-info")],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "viewer-layer",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.isVrMode && _vm.markerInfoData.type === "gallery",
              expression: "!isVrMode && markerInfoData.type === 'gallery'",
            },
          ],
          staticClass: "bounce-in",
          class: { "bounce-in-active": _vm.isMarkerInfoActive },
          attrs: {
            "close-event": _vm.closeMarkerInfo,
            "inner-class-name": "viewer-layer-enlarge height-auto",
          },
          scopedSlots: _vm._u([
            {
              key: "inner-extra",
              fn: function () {
                return [
                  _vm.favoritesMarkerTypes.includes(_vm.markerInfoData.type)
                    ? _c("i-favorite", {
                        attrs: { category: "marker", item: _vm.markerInfoData },
                      })
                    : _vm._e(),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [_vm._v(" "), _c("marker-info")],
        1
      ),
      _vm._v(" "),
      _vm.isMarkerFinderEnable
        ? _c(
            "viewer-layer",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.shouldViewerLayerShow,
                  expression: "shouldViewerLayerShow",
                },
              ],
              staticClass: "bounce-in",
              class: { "bounce-in-active": _vm.isSearchActive },
              attrs: {
                "close-event": _vm.closeSearchs,
                "inner-class-name": "viewer-layer-second-inner fullscreen",
              },
            },
            [
              _c(
                "div",
                { staticClass: "search-wrap h-100" },
                [
                  _vm.isSearchInit
                    ? [
                        _c(
                          "div",
                          { staticClass: "search-block" },
                          [
                            _c("i-category-select", {
                              staticClass: "category-search",
                            }),
                            _vm._v(" "),
                            _c("i-marker-search", {
                              staticClass: "marker-search",
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("search-list", {
                          attrs: {
                            "is-search-result-null-for-taiwantrade":
                              _vm.isSearchResultNullForTaiwantrade,
                          },
                          on: {
                            gotoTarget: _vm.gotoTarget,
                            close: _vm.closeSearchs,
                          },
                        }),
                      ]
                    : [
                        _c("div", { staticClass: "search-loading" }, [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/images/loading.svg"),
                            },
                          }),
                        ]),
                      ],
                ],
                2
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showComment
        ? _c(
            "viewer-layer",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.shouldViewerLayerShow,
                  expression: "shouldViewerLayerShow",
                },
              ],
              staticClass: "bounce-in",
              class: { "bounce-in-active": _vm.isCommentsActive },
              attrs: {
                "close-event": _vm.closeComments,
                "inner-class-name": "viewer-layer-second-inner",
              },
            },
            [
              _c("ul", { staticClass: "viewer-layer-tabs" }, [
                _c(
                  "li",
                  { staticClass: "viewer-layer-li viewer-layer-li-active" },
                  [
                    _c("span", { staticClass: "viewer-layer-text" }, [
                      _vm._v(_vm._s(_vm.$t("comment"))),
                    ]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "viewer-layer-container" },
                [
                  _c("comments-list", {
                    on: { setCommentsEl: _vm.setCommentsEl },
                  }),
                  _vm._v(" "),
                  _c("comments-input", {
                    on: {
                      "set-comments-el-scroll-to-top":
                        _vm.setCommentsElScrollToTop,
                    },
                  }),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "viewer-layer",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.shouldViewerLayerShow,
              expression: "shouldViewerLayerShow",
            },
          ],
          staticClass: "bounce-in",
          class: { "bounce-in-active": _vm.isInformationActive },
          attrs: { "close-event": _vm.closeInformation },
        },
        [
          _c("ul", { staticClass: "viewer-layer-tabs" }, [
            _c(
              "li",
              { staticClass: "viewer-layer-li viewer-layer-li-active" },
              [
                _c("span", { staticClass: "viewer-layer-text" }, [
                  _vm._v(_vm._s(_vm.$t("propertyInfo"))),
                ]),
              ]
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "viewer-layer-container" },
            [
              _c("information", {
                attrs: {
                  name: _vm.property.name,
                  description: _vm.property.description,
                },
              }),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _vm.shouldGoogleMapActive
        ? _c(
            "viewer-layer",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.shouldViewerLayerShow,
                  expression: "shouldViewerLayerShow",
                },
              ],
              staticClass: "bounce-in",
              class: { "bounce-in-active": _vm.isLocationActive },
              attrs: { "close-event": _vm.closeLocation },
            },
            [
              _c("ul", { staticClass: "viewer-layer-tabs" }, [
                _c(
                  "li",
                  { staticClass: "viewer-layer-li viewer-layer-li-active" },
                  [
                    _c("span", { staticClass: "viewer-layer-text" }, [
                      _vm._v(_vm._s(_vm.$t("location"))),
                    ]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "viewer-layer-container" },
                [
                  _c("i-map", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isLocationActive,
                        expression: "isLocationActive",
                      },
                    ],
                    attrs: {
                      lat: _vm.currentBuilding.geoLatitude,
                      lng: _vm.currentBuilding.geoLongitude,
                    },
                  }),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "viewer-layer",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.shouldViewerLayerShow && _vm.isShareReady,
              expression: "shouldViewerLayerShow && isShareReady",
            },
          ],
          staticClass: "bounce-in",
          class: { "bounce-in-active": _vm.isShareActive },
          attrs: { "close-event": _vm.closeShare },
        },
        [
          _c("ul", { staticClass: "viewer-layer-tabs" }, [
            _c(
              "li",
              { staticClass: "viewer-layer-li viewer-layer-li-active" },
              [
                _c("span", { staticClass: "viewer-layer-text" }, [
                  _vm._v(_vm._s(_vm.$t("share"))),
                ]),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "viewer-layer-container" }, [
            _c(
              "div",
              { staticClass: "share-container" },
              [
                _vm.shareUrl.qrcode
                  ? _c("qr-code", { attrs: { url: _vm.shareUrl.qrcode } })
                  : _vm._e(),
                _vm._v(" "),
                _c("share-list"),
                _vm._v(" "),
                _vm.isIframe
                  ? _c("button", {
                      staticClass: "btn-close",
                      domProps: { textContent: _vm._s(_vm.$t("close")) },
                      on: { click: _vm.closeShare },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("narrator", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value:
              !_vm.shouldPilotRecorderActive && !_vm.shouldPilotPlayerActive,
            expression:
              "!shouldPilotRecorderActive && !shouldPilotPlayerActive",
          },
        ],
        attrs: { "should-panoramas-list-show": _vm.shouldPanoramasListShow },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "main-float-btns" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.currentBuilding.homeButtonEnable,
                expression: "currentBuilding.homeButtonEnable",
              },
            ],
            staticClass: "home-btn",
            style: {
              pointerEvents: _vm.isMobileMenuActive ? "none" : "auto",
            },
            on: { click: _vm.homeIconClick },
          },
          [_c("i", { staticClass: "isif isif-home home-icon" })]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.isHideMenu,
                expression: "!isHideMenu",
              },
            ],
            staticClass: "expand-btn",
            style: {
              pointerEvents: _vm.isMobileMenuActive ? "none" : "auto",
            },
            on: { click: _vm.expandMenuIconClick },
          },
          [_c("i", { staticClass: "isif isif-expand expand-icon" })]
        ),
      ]),
      _vm._v(" "),
      _c(
        "section",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.shouldViewerLayerShow,
              expression: "shouldViewerLayerShow",
            },
          ],
          staticClass: "main-footer",
          class: { "main-footer-active": _vm.shouldPanoramasListShow },
        },
        [
          _c("div", { staticClass: "main-footer-tool" }, [
            _c("div", { staticClass: "main-footer-tool-1" }, [
              _c(
                "button",
                {
                  staticClass: "main-viewer-list-collapse",
                  attrs: { type: "button" },
                  on: { click: _vm.togglePanoramasList },
                },
                [
                  _c("i", {
                    staticClass: "isif",
                    class: _vm.shouldPanoramasListShow
                      ? "isif-arrow-down"
                      : "isif-arrow-up",
                  }),
                ]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("viewer-list", { staticClass: "main-viewer-list" }),
        ],
        1
      ),
      _vm._v(" "),
      !_vm.currentBuilding.floorplanSize &&
      _vm.floorplan &&
      _vm.floorplan !== "none"
        ? _c(
            "section",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.shouldViewerLayerShow,
                  expression: "shouldViewerLayerShow",
                },
              ],
              staticClass: "floorplan-wrapper",
              class: {
                "floorplan-wrapper-active": _vm.shouldFloorplanShow,
                "floorplan-wrapper-has-buildings": _vm.property.objectId,
              },
            },
            [
              _c("floorplan", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isFloorplanReady,
                    expression: "isFloorplanReady",
                  },
                ],
                staticClass: "floorplan-self",
                attrs: {
                  "floorplan-container-width": _vm.floorplanContainerWidth,
                  "floorplan-container-height": _vm.floorplanContainerHeight,
                  "is-resizable": true,
                  "is-draggable": true,
                },
              }),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "floorplan-wrapper-collapse",
                  on: { click: _vm.toggleFloorplan },
                },
                [
                  _c("icon", {
                    class: {
                      "icon-collapse-right": !_vm.isFloorplanActive,
                      "icon-collapse-left": _vm.isFloorplanActive,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !!_vm.currentBuilding.floorplanSize &&
      _vm.floorplan &&
      _vm.floorplan !== "none"
        ? _c(
            "section",
            {
              staticClass: "enlarge-floorplan-wrapper",
              class: {
                "enlarge-floorplan-wrapper-active": _vm.shouldFloorplanShow,
              },
            },
            [_c("EnlargeFloorplan")],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("instructions"),
      _vm._v(" "),
      _vm.isPopupActive
        ? _c("popup", {
            attrs: {
              url: _vm.popupUrl,
              type: _vm.popupSizeConfig.type,
              "full-height": _vm.popupSizeConfig.fullHeight,
              "width-percent": _vm.popupSizeConfig.widthPercent,
              transparent: _vm.popupSizeConfig.transparent,
              marker: _vm.popupMarker,
            },
            on: { closePopup: _vm.closePopup },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isArViewPopupActive
        ? _c("popup-ar-view", { on: { closeMarkerInfo: _vm.closeMarkerInfo } })
        : _vm._e(),
      _vm._v(" "),
      _c("VisitorWelcome", {
        staticClass: "bounce-in",
        class: { "bounce-in-active": _vm.isVisitorInfoActive },
      }),
      _vm._v(" "),
      _c("MusicPlayer", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.shouldMusicPlayerShow,
            expression: "shouldMusicPlayerShow",
          },
        ],
        ref: "MusicPlayer",
        staticClass: "i-main-music-player",
        on: {
          pause: _vm.onMusicPlayerPause,
          playing: _vm.onMusicPlayerPlaying,
          stop: function ($event) {
            return _vm.setMusicPlayerActive(false)
          },
          ended: function ($event) {
            return _vm.setMusicPlayerActive(false)
          },
        },
      }),
      _vm._v(" "),
      _vm.shouldPilotRecorderActive ? _c("pilot-recorder") : _vm._e(),
      _vm._v(" "),
      _c("pilot-player"),
      _vm._v(" "),
      _c("vr-lounge"),
      _vm._v(" "),
      _vm.currentMarker && _vm.currentMarker.type === "videoplay"
        ? _c("fullscreen-video", {
            staticStyle: { "z-index": "5" },
            attrs: {
              url: _vm.currentMarker.actionLink,
              "is-fullscreen": _vm.isVideoplayFullscreen,
            },
            on: {
              change: function ($event) {
                "isFullscreen" in $event && _vm.exitFullscreenVideo()
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("favorites-dialog", {
        attrs: {
          "layer-visible": _vm.shouldViewerLayerShow,
          "goto-target": _vm.gotoTarget,
        },
      }),
      _vm._v(" "),
      _c("pilot-mask"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }